import type { ControllerConfig, ValueState } from '../../types'

import { Operators } from '@/shared/components/query-builder'

import FieldController from '../Controller'

export default class BooleanController extends FieldController {
	constructor(config: ControllerConfig) {
		super(config)
		this.note = config.note
		this.validate = config.validate || this.defaultValidate
	}

	note?: string

	formatLabel = () => this.label

	hasValue = () => true
	defaultValidate = ({ value }: ValueState) =>
		value !== '0' && value !== '1' ? 'Please select a value.' : null
	getInitialValue = () => ({
		operation: Operators.BL,
		value: '',
	})
}
